// extracted by mini-css-extract-plugin
module.exports = {"container":"video_container__1C9Xb","video":"video_video__1E0Dg","cover":"video_cover__3EMHJ video_video__1E0Dg","contain":"video_contain__3qolo video_video__1E0Dg"};